
import React from 'react';
import { Button } from '@/components/ui/button';
import { MapPin } from 'lucide-react';

interface LocationControlsProps {
  selectedLocation: string;
  featuredLocations: string[];
  onLocationChange: (location: string) => void;
}

const LocationControls: React.FC<LocationControlsProps> = ({ 
  selectedLocation, 
  featuredLocations, 
  onLocationChange 
}) => {
  return (
    <div className="mb-12">
      <h2 className="text-2xl font-bold text-brand-charcoal-gray mb-6 flex items-center gap-2">
        <MapPin className="h-6 w-6 text-brand-trophy-gold" />
        Browse by Location
      </h2>
      
      <div className="flex flex-wrap gap-3">
        <Button
          variant={selectedLocation === 'raleigh' ? 'default' : 'outline'}
          onClick={() => onLocationChange('raleigh')}
          className={`flex items-center gap-2 ${
            selectedLocation === 'raleigh' 
              ? 'bg-brand-trophy-gold hover:bg-brand-trophy-gold/90 text-black' 
              : 'border-brand-charcoal-gray text-brand-charcoal-gray hover:bg-brand-charcoal-gray hover:text-white'
          }`}
        >
          <MapPin className="h-4 w-4" />
          Raleigh
        </Button>
        {featuredLocations.map(location => (
          <Button
            key={location}
            variant={selectedLocation === location.toLowerCase() ? 'default' : 'outline'}
            onClick={() => onLocationChange(location.toLowerCase())}
            className={`flex items-center gap-2 ${
              selectedLocation === location.toLowerCase()
                ? 'bg-brand-trophy-gold hover:bg-brand-trophy-gold/90 text-black' 
                : 'border-brand-charcoal-gray text-brand-charcoal-gray hover:bg-brand-charcoal-gray hover:text-white'
            }`}
          >
            <MapPin className="h-4 w-4" />
            {location}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default LocationControls;
